<template>
  <div class="room-detail room-detail-custom">
    <div
      v-b-toggle="`room_${roomDetailSumary.roomIdx}`"
      class="room-detail__collapse"
      ref="roomCollapse"
      @click="onCollapse"
    >
      <div class="room-detail__name">
        {{ $t("booking.room") }} {{ roomDetailSumary.roomIdx + 1 }}
      </div>
      <div
        class="room-detail__stats"
        :class="{ 'mr-0': roomList.length === 1 }"
      >
        <div>
          <span>
            {{ roomDetail.room.adults.number }}
            {{
              roomDetail.room.adults.number > 1
                ? $t("booking.adults")
                : $t("booking.adult")
            }}
          </span>
          <span v-if="roomDetail.room.children.childrenList.length">
            ,
            {{ roomDetail.room.children.childrenList.length }}
            {{
              roomDetail.room.children.childrenList.length > 1
                ? $t("booking.children")
                : $t("booking.child")
            }}
          </span>
        </div>
        <div
          class="room-detail__stats__message"
          :class="{ 'r-0': roomList.length === 1 }"
        >
          {{ roomStatus ? $t("booking.no_room_available") : "" }}
        </div>
      </div>
    </div>
    <slot />
  </div>
</template>

<script>
/* eslint-disable vue/require-default-prop */
import Vue from "vue";
import { VBToggle } from "bootstrap-vue";
import { mapGetters, mapState } from "vuex";
Vue.directive("b-toggle", VBToggle);

export default {
  name: "RoomDetailSumary",
  components: {},
  props: {
    roomDetailSumary: {
      type: Object,
    },
  },
  data() {
    return {
      roomDetail: this.roomDetailSumary,
    };
  },
  computed: {
    ...mapState({
      roomList: (state) => state.roomList,
      roomActive: (state) => state.currentRoomActive,
    }),
    ...mapGetters({
      roomListStatus: "roomListStatus",
    }),

    roomStatus() {
      return (
        this.roomListStatus &&
        this.roomListStatus[this.roomDetailSumary.roomIdx]
      );
    },
  },
  watch: {
    roomDetailSumary(data) {
      this.roomDetail = data;
    },
  },
  methods: {
    onCollapse(visible) {
      const { offsetTop } = this.$refs["roomCollapse"];
      this.$emit("on:sendRoomOffsetTop", offsetTop);
    },
  },
};
</script>

<style lang="scss" scoped>
.room-detail {
  display: flex;
  font-weight: bold;
  justify-content: space-between;
  border-bottom: 1px solid #dddee0;
  cursor: pointer;
  // padding-bottom: 15px;
  &__name {
    font-size: 14px;
    flex-grow: 1;
    outline: none;
    text-align: left;
  }
  &__stats {
    color: #3b61a7;
    font-size: 12px;
    margin-right: 20px;
    outline: none;
    margin-left: 25px;

    &__message {
      position: absolute;
      color: red;
      right: -10px;
    }

    .r-0 {
      right: -1px;
    }
  }
  .mr-0 {
    margin-right: 0;
  }
  &__delete {
    cursor: pointer;
    padding-bottom: 15px;
  }

  &__collapse {
    display: flex;
    flex: 1;
    justify-content: space-between;
    align-items: center;
    outline: none;
    padding-bottom: 15px;
    position: relative;
  }
}
</style>
